import { cx } from "../../lib/cx.js";
/* empty css           */
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Avatar/Avatar.tsx
/** Up to two initials: the first and last words' first letters, or a single word's first two. */
function initialsOf(name) {
	const words = name.trim().split(/\s+/).filter(Boolean);
	if (words.length === 0) return "?";
	if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
	return (words[0][0] + words.at(-1)[0]).toUpperCase();
}
/** One of five tones, the same for the same name every time. */
function toneOf(name) {
	let hash = 0;
	for (let index = 0; index < name.length; index++) hash = hash * 31 + name.charCodeAt(index) >>> 0;
	return hash % 5;
}
/**
* A person's photo, or their initials on a tone picked from their name. It is an image
* named by `name` (and `status`), unless `decorative`.
*/
function Avatar({ name, src, size = "md", square = false, status, decorative = false, className, ...rest }) {
	const [failedSrc, setFailedSrc] = useState();
	const showImage = src != null && src !== "" && src !== failedSrc;
	const label = status ? `${name}, ${status}` : name;
	return /* @__PURE__ */ jsxs("span", {
		className: cx("ds-avatar", `ds-avatar--${size}`, !showImage && `ds-avatar--tone-${toneOf(name)}`, square && "ds-avatar--square", className),
		...decorative ? { "aria-hidden": true } : {
			role: "img",
			"aria-label": label
		},
		...rest,
		children: [showImage ? /* @__PURE__ */ jsx("img", {
			className: "ds-avatar__img",
			src,
			alt: "",
			onError: () => setFailedSrc(src)
		}) : /* @__PURE__ */ jsx("span", {
			className: "ds-avatar__initials",
			children: initialsOf(name)
		}), status && /* @__PURE__ */ jsx("span", { className: cx("ds-avatar__status", `ds-avatar__status--${status}`) })]
	});
}
//#endregion
export { Avatar, initialsOf, toneOf };

//# sourceMappingURL=Avatar.js.map